const FLOW_STATE_KEY = "medsynciq_auth_flow";

export interface AuthFlowState {
  email: string;
  fromSignup?: boolean;
  /** Epoch ms when the current OTP expires — lets a page refresh resume the real countdown. */
  otpExpiresAt?: number;
  /** Epoch ms until resend is allowed again (cooldown or hourly cap) — same reason. */
  resendBlockedUntil?: number;
}

export function saveAuthFlowState(state: AuthFlowState) {
  sessionStorage.setItem(FLOW_STATE_KEY, JSON.stringify(state));
}

export function getAuthFlowState(): AuthFlowState | null {
  const raw = sessionStorage.getItem(FLOW_STATE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as AuthFlowState;
  } catch {
    return null;
  }
}

/** Merges into the stored state for `email` instead of replacing it wholesale. */
export function updateAuthFlowState(email: string, patch: Partial<Omit<AuthFlowState, "email">>) {
  const current = getAuthFlowState();
  const base: AuthFlowState = current && current.email === email ? current : { email };
  saveAuthFlowState({ ...base, ...patch });
}

export function clearAuthFlowState() {
  sessionStorage.removeItem(FLOW_STATE_KEY);
}
